export interface SuccessAction<TData> {
  data: TData | undefined;
  type: 'success';
  dataUpdatedAt?: number;
}
export const protectQueryAction = <TData>(action: any): action is SuccessAction<TData> =>
  action.type === 'success' && (action as SuccessAction<TData>).data ? true : false;
